export const MceYearType = {
	FIRST: 'FIRST',
	SECOND: 'SECOND',
	THIRD: 'THIRD',

	values: () => {
		return ['FIRST', 'SECOND', 'THIRD'];
	},
};
